<template>
    <div class="sign-up">
        <div v-if="step ==1">
            <!-- Notice -->
        <h4> {{ $t("messages.notice") }}</h4>
        <terms :company="company" style="height:350px"></terms>
        <form @submit.prevent="terms">
            <div class="form-group" :class="{ 'form-group--error': $v.form2.terms.$error }" >
                <b-form-checkbox class="form-control"
                    id="checkbox-1"
                    v-model="$v.form2.terms.$model"
                    name="checkbox-1"
                    value=true
                    unchecked-value="false">
                     {{ $t("messages.gdpr.accept") }}
                </b-form-checkbox> 
            </div>
            <div v-if="$v.form2.$error">
                <div class="error" v-if="!$v.form2.terms.sameAs"> {{ $t('messages.login.error.terms') }}</div>
            </div>
            <!-- CANCEL ACCEPT -->
            <button v-b-modal="'cancel'" type="clear" class="button cancel" style="margin-top:15px;">
                    {{ $t("messages.cancel") }}
            </button>
              <button type="submit" class="button" style="margin-top:15px">
                    {{ $t("messages.accept") }}
            </button>
            
        </form>
    </div>
    <div v-else-if="step == 2" class="sign-up">
        <!-- Update your information -->
        <h4>{{ $t("messages.infoUpdate") }}</h4>
        <form @submit.prevent="personal">

                <div class="form-group" :class="{ 'form-group--error': $v.form.name.$error }">
                    <label class="form__label">{{ $t("messages.login.fullName") }}*</label>
                    <input class="form-control" v-model.trim="$v.form.name.$model"/>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.name.required">{{ $t('messages.login.error.required') }}</div>
                    <div class="error" v-if="!$v.form.name.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.name"), value: $v.form.name.$params.minLength.min }) }}</div>
                </div>

                <div class="form-group" :class="{ 'form-group--error': $v.form.country.$error }">
                    <label class="form__label">{{ $t("messages.login.country") }}*</label>
                    <b-form-select class="form-control"  v-model="$v.form.country.$model" :options="countries" :placeholder="$t('messages.login.country')"/>
                    
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.country.required">{{ $t('messages.login.error.required') }}</div>
                </div>

                <div class="form-group">
                    <label class="form__label">{{ $t("messages.login.phone") }}</label>
                    <input class="form-control" v-model.trim="userProfile.phone" maxlength="20"/>
                </div>
     
                <div class="form-group">
                    <label class="form__label">{{ $t("messages.language") }}</label>
                    <select class="form-control" :required="true" v-model="userProfile.language">
                        <option 
                            v-for="option in languages" :key="option.code" 
                            v-bind:value="option.code"
                            :selected="option.code == userProfile.language"
                            >{{ option.name }}
                        </option>
                        </select>
                    </div>

                <button v-b-modal="'cancel'" type="clear" class="button cancel" style="margin-top:15px;">
                        {{ $t("messages.cancel") }}
                </button>
                <button type="submit" class="button" style="margin-top:15px">
                        {{ $t("messages.update") }}
                </button>
        </form>
    </div>
    <div v-else class="sign-up">
        <!-- Update your password (optional) -->
        <h4> {{ $t("messages.passwordUpdate") }} ({{ $t("messages.optional") }})</h4>
        <form @submit.prevent="password">
                <div class="form-group" :class="{ 'form-group--error': $v.form3.password.$error }">
                    <label class="form__label">{{ $t("messages.login.password") }}</label>
                    <input class="form-control" type="password" v-model.trim="$v.form3.password.$model"/>
                </div>
                <div v-if="$v.form3.$error">
                    <div class="error" v-if="!$v.form3.password.required">{{ $t('messages.login.error.required') }}</div>
                    <div class="error" v-if="!$v.form3.password.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.password"), value: $v.form3.password.$params.minLength.min }) }} </div>
                </div>
            
                <div class="form-group" :class="{ 'form-group--error': $v.form3.repeatPassword.$error }">
                    <label class="form__label">{{ $t("messages.login.repeatPassword") }}</label>
                    <input class="form-control" type="password" v-model.lazy="$v.form3.repeatPassword.$model" data-vv-validate-on="blur" />
                </div>
                <div v-if="$v.form3.$error">
                    <div class="error" v-if="!$v.form3.repeatPassword.sameAsPassword"> {{ $t('messages.login.error.passwordIdentical') }}</div>
                </div>
                <!-- Update your password Continue -->
                <button type="submit" class="button" style="margin-top:15px">
                   {{ $t("messages.updatePassword") }}
                </button>
                <button @click="onFinish" class="button" style="margin-top:15px">
                    {{ $t("messages.continue") }}
                </button>
        </form>
    </div>
     <b-modal id="cancel"
            ref="modal"
            title="Cancel">
            <b-container>
                <!-- To manage your pools, you have to finish the process / Are you sure you want to finish the process ? -->
                <p>{{ $t("messages.poolManagement") }}. <strong>{{ $t("messages.processEnd") }}</strong>? </p>
            </b-container>
            <div slot="modal-footer" class="w-100">
                <button class="float-right btn btnPerso delete" @click="onCancel">
                    <!-- Finish -->
                    {{ $t("messages.finish") }}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Terms from './Terms.vue'
import {required, sameAs, minLength} from 'vuelidate/lib/validators';
import {
    mapState
} from 'vuex';

export default {
    name: 'GDPR',
    components: { Terms },
    props: {
        company: Number
    },
    data: function () {
        return {
            step:1,
            form: {
                name: "",
                country: ""
            },
            form2:{
                terms:"",
            },
            form3:{
                password: "",
                repeatPassword:"",
            }
        }
    },
    validations: {
        form: {
            name: {
                required,
                minLength: minLength(4)
            },
            country: {
                required
            }
        },
        form2:{
            terms: {
                sameAs: sameAs( () => 'true' ),
            }
        },
        form3:{
            password: {
                required,
                minLength: minLength(6)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
        
    },
    created(){
      this.setCountries()
    },
    computed: {
        countriesList: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            this.$v.form.country.$model = (this.languages[index].code !='en') ? this.languages[index].code.toUpperCase() : 'ES'
            return this.languages[index].countries;
        },
        ...mapState(['currentUser', 'userProfile', 'languages']),
    },
    methods:{
        setCountries(){
          this.countries = this.countriesList
        },
        terms(){
            this.$v.form2.$touch();
            if (this.$v.form2.$error){
                return
            }
            this.step = 2
            this.$emit('onResize');
        },
        personal() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
            this.$snotify.async(this.$t("messages.alertUpdatingUser"), () => new Promise((resolve, reject) => {
                this.$store.dispatch('updateProfile',
                  {
                      GDPR: true,
                      name: this.form.name,
                      country: this.form.country,
                      phone: (this.userProfile.phone && this.userProfile.phone !='')? this.userProfile.phone : '',
                      language: this.userProfile.language
                  }
                ).then(response => {
                   resolve({
                    //    Info updated
                        body:  this.$t("messages.infoUpdated") ,
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                    // this.step = 3
                    this.$emit('onFinish');
                }, error => {
                    reject({
                        // Error updating user
                        body: this.$t("messages.userUpdateError") ,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
        password() {
            console.log('set password');
            this.$v.form3.$touch();
            if (this.$v.form3.$error){
                return
            }
            // Updating password, Sending data
            this.$snotify.async(this.$t("messages.alertUpdatingPassword"), () => new Promise((resolve, reject) => {
                this.currentUser.updatePassword(this.form3.password).then( ()=> {
                    this.$v.form3.$reset();
                    this.form3.password = '';
                    this.form3.repeatPassword = '';
                    resolve({
                        // Password updated
                        body:this.$t("messages.passwordUpdated"),
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    this.$modal.show('login-box');
                    reject()
                });
            }))  
        },
     
        onCancel(){
            //this.$emit('onCancel');
            window.location.reload()
        },
        onFinish() {
            this.$emit('onFinish');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/GDPR.vue